module.exports = __webpack_public_path__ + "img/icon-warning-thunder-orange.58a63e79.svg";